import React, { useState } from "react";
import { ImageDown, Copy, FileText, Share, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "../ui/dropdown-menu";
import { downloadCardPng, copyCardPng, downloadCardPdf } from "../../lib/share";

export default function ShareMenu({ cardRef, title, disabled }) {
  const [busy, setBusy] = useState(false);

  const run = async (fn, okMsg) => {
    if (!cardRef.current) return;
    setBusy(true);
    try {
      await fn(cardRef.current, title);
      toast.success(okMsg);
    } catch (err) {
      toast.error("Could not create the share card", { description: err?.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="tb-btn sm" disabled={disabled || busy} data-testid="share-card-menu">
          {busy ? <Loader2 size={13} className="spin" /> : <Share size={13} />} Share card
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => run(downloadCardPng, "PNG downloaded")} data-testid="share-png">
          <ImageDown size={14} /> Download PNG
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run(copyCardPng, "Image copied to clipboard")} data-testid="share-copy">
          <Copy size={14} /> Copy image
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run(downloadCardPdf, "PDF downloaded")} data-testid="share-pdf">
          <FileText size={14} /> Save as PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
